import React from 'react';

export interface IUserSurveyProps {
  feedback: any;
  onChange: (value: any) => void;
}

export default function UserSurvey(_props: IUserSurveyProps) {
  return (
    <>
      <p className="one-last-thing explanatory-text-secondary explanatory-italic">just one last thing before you go…</p>
    </>
  );
}
